import URL_ROUTE, { IP_ORIGEN_URL } from '../constants/index';

class Api {

    async obtenerIpOrigen() {
        try {
            const query = await fetch(IP_ORIGEN_URL);
            const dataJson = await query.json();
            return dataJson?.ip || null
        } catch (e) {
            console.log("Error al obtener IP de origen =>", e)
            return null
        }
    }

    async registrarOrigenLead({ip_origen, url_origen}) {
        const data = {ip_origen, url_origen}
        const query = await fetch(`${URL_ROUTE.REGISTRARORIGENLEAD}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async guardarFormWeb({colegio, estudiantes, modulos, mensaje, recaptcha}) {
        console.log({colegio, estudiantes, modulos, mensaje, recaptcha}, "data")
        const data = {colegio, estudiantes, modulos, mensaje, recaptcha}
        const query = await fetch(`${URL_ROUTE.GUARDARFORMWEB}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async guardarCRMFormWeb({colegio, nombre, cargo, estudiantes, email, telefono, modulos, mensaje, recaptcha, origen_id}) {
        const data = {colegio, nombre, cargo, estudiantes, email, telefono, modulos, mensaje, recaptcha, origen_id}
        const query = await fetch(`${URL_ROUTE.GUARDARCRMFORMWEB}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }
}

export default new Api();
